import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ErrorTextComponent} from './error-text.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
    ],
    exports: [
        ErrorTextComponent,
    ],
    declarations: [
        ErrorTextComponent
    ]
})
export class ErrorTextModule {
}
